import React, { useEffect, useRef } from 'react';

const CrowdRiffGallery = ({
	scriptUrl = 'https://starling.crowdriff.com/js/crowdriff.js',
	hash,
	allowUpdate,
}) => {
	const wrapperRef = useRef(null);

	useEffect(() => {
		// Warn if this script is being used outside of platform without the correct scriptUrl
		if (
			process.env.NODE_ENV !== 'development' &&
			scriptUrl.indexOf('crowdriff.com') === -1 &&
			window.location.href.indexOf('//platform.') === -1
		) {
			console.warn('Invalid scriptUrl prop passed to CrowdRiffGallery component.');
		}

		const script = document.createElement('script');
		script.src = scriptUrl;
		script.id = `cr-init__${hash}`;
		script.async = true;

		wrapperRef.current?.appendChild(script);

		if (
			window.crowdriff__gallery &&
			!window.crowdriff__gallery.interval
		) {
			window.crowdriff__gallery.interval = setInterval(
				window.crowdriff__gallery.processQueue,
				300
			);
		}

		return () => {
			if (window.crowdriff__gallery?.rendered) {
				window.crowdriff__gallery.rendered =
					window.crowdriff__gallery.rendered.filter(
						(id) => id !== `cr__${hash}`
					);
			}
		};
	}, [scriptUrl, hash]);

	if (!hash) {
		console.warn('No gallery hash passed to CrowdRiff gallery component');
	}

	return (
		<div
			ref={wrapperRef}
			id={`gallery-wrapper-${hash}`}
		/>
	);
};

export default React.memo(
	CrowdRiffGallery,
	(prevProps, nextProps) => {
		if (nextProps.allowUpdate) {
			return false;
		}
		return true;
	}
);